import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeAr from '@angular/common/locales/ar';
import localeArAe from '@angular/common/locales/ar-AE';
import dayjs from 'dayjs';
import { TranslateService } from '@ngx-translate/core';
import 'dayjs/locale/es';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  public importantPopupShown$ = new BehaviorSubject(false);
  constructor(private translate: TranslateService) {}

  getLanguage(): string {
    const defaultLocale = 'en-US';
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return defaultLocale;
    }
    const wn = window.navigator as any;
    let lang = wn.languages ? wn.languages[0] : defaultLocale;
    lang = lang || wn.userLanguage || wn.language || wn.browserLanguage;
    return ['en', 'es'].some(x => x === lang.slice(0, 2)) ? lang : defaultLocale;
  }

  getSelectedLanguage(): string {
    return localStorage.getItem('locale') || this.getLanguage();
  }

  localise() {
    const usersLocale = localStorage.getItem('locale') || this.getLanguage();
    localStorage.setItem('locale', usersLocale);
    registerLocaleData(localeEs);
    registerLocaleData(localeAr);
    registerLocaleData(localeArAe);
    this.translate.use(usersLocale.slice(0, 2));
    dayjs.locale(usersLocale.slice(0, 2));
    dayjs.Ls.en.weekStart = 1;
  }

  setLanguage(locale: string) {
    localStorage.setItem('locale', locale);
    this.translate.use(locale);
    dayjs.locale(locale.slice(0, 2));
    window.location.reload();
  }
}
